export default __webpack_public_path__ + "media/src/assets/images/map-48ae1bd40dea2a79ace381dff5515ee7.png";